import { render, staticRenderFns } from "./DocumentosSalidaCRUD.vue?vue&type=template&id=4f8b1406"
import script from "./DocumentosSalidaCRUD.vue?vue&type=script&lang=js"
export * from "./DocumentosSalidaCRUD.vue?vue&type=script&lang=js"
import style0 from "./DocumentosSalidaCRUD.vue?vue&type=style&index=0&id=4f8b1406&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports